const USER_STUDENT_PROFILE = 'student'
const USER_STAFF_PROFILE = 'staff'
const USER_BOOK_TEACHER_PROFILE = 'teacher'
const USER_ACCOUNTABLE_PROFILE = 'accountable'
const USER_RESPONSIBLE_PROFILE = 'responsible'
const USER_UNAVAILABLE_PROFILE = 'unavailable'
const USER_SERVICE_PROFILE = 'service'

const VOUCHER_ACTIVATED_STUDENT = 'Code: 001'
const VOUCHER_ACTIVATED_TEACHER = 'Code: 002'
const VOUCHER_WITHOUT_CAMPAINGS = 'Code: 003'
const VOUCHER_CANCELED = 'Code: 004'
const VOUCHER_ENDED = 'Code: 005'
const VOUCHER_EXPIRED = 'Code: 006'
const VOUCHER_NOT_FOUND = 'Code: 007'
const VOUCHER_WITHOUT_MATERIALS = 'Code: 008'
const VOUCHER_EXPIRED_OR_USED = 'Code: 009'
const VOUCHER_EXPIRED_OR_USED_SCHOOL_STAFF = 'Code: 010'
const VOUCHER_EASY_BOOK_ACTIVATED = 'Code: 011'
const VOUCHER_EASY_BOOK_EXPIRED = 'Code: 012'

const ROLE_ADMIN_ID = 1
const ROLE_TEACHER_ID = 3
const ROLE_COORDINATOR_ID = 4
const ROLE_DIRECTOR_ID = 5
const ROLE_STUDENT_ID = 6
const ROLE_RESPONSIBLE_ID = 11
const ROLE_ATTENDANT_ID = 21

const ACTIVE_USER = 1
const PENDING_USER = 2

const EASY_BOOK_TYPE_ID = 10
const HIGH_SCHOOL_LEVEL_ID = 7

const PASSWORD_MIN_LENGTH = 8

const COOKIE_RESPONSIBLE_URL = 'cookie_responsible_url'
const ACCESS_CODE_COOKIE_NAME = 'access_code_shared_cookie'

const INTERESTED_ROLE_ID_RESPONSIBLE = 'RESPONSIBLE'

const GENDER_MASCULINE = 'M'

export {
  ACTIVE_USER,
  EASY_BOOK_TYPE_ID,
  HIGH_SCHOOL_LEVEL_ID,
  PASSWORD_MIN_LENGTH,
  PENDING_USER,
  ROLE_ADMIN_ID,
  ROLE_TEACHER_ID,
  ROLE_COORDINATOR_ID,
  ROLE_DIRECTOR_ID,
  ROLE_RESPONSIBLE_ID,
  ROLE_ATTENDANT_ID,
  USER_ACCOUNTABLE_PROFILE,
  USER_STUDENT_PROFILE,
  USER_STAFF_PROFILE,
  ROLE_STUDENT_ID,
  USER_RESPONSIBLE_PROFILE,
  USER_BOOK_TEACHER_PROFILE,
  USER_UNAVAILABLE_PROFILE,
  VOUCHER_ACTIVATED_STUDENT,
  VOUCHER_ACTIVATED_TEACHER,
  VOUCHER_WITHOUT_CAMPAINGS,
  VOUCHER_CANCELED,
  VOUCHER_EASY_BOOK_ACTIVATED,
  VOUCHER_ENDED,
  VOUCHER_EXPIRED,
  VOUCHER_NOT_FOUND,
  VOUCHER_WITHOUT_MATERIALS,
  VOUCHER_EXPIRED_OR_USED,
  ACCESS_CODE_COOKIE_NAME,
  USER_SERVICE_PROFILE,
  COOKIE_RESPONSIBLE_URL,
  INTERESTED_ROLE_ID_RESPONSIBLE,
  GENDER_MASCULINE,
  VOUCHER_EXPIRED_OR_USED_SCHOOL_STAFF,
  VOUCHER_EASY_BOOK_EXPIRED,
}

export const DEFAULT_CRITICAL_ERROR_MESSAGE =
  'Ops! Ocorreu um erro. Caso o erro persista, entre em contato com o suporte.'

export const NO_PERMISSION_IMAGE_URL = `${process.env.REACT_APP_ASSETS_URL}/images/with-out-permission.svg`

export const NOT_FOUND_IMAGE_URL = `${process.env.REACT_APP_ASSETS_URL}/images/tired.svg`

export const DEFAULT_ERROR_IMAGE_URL = `${process.env.REACT_APP_ASSETS_URL}/images/what.svg`

export const CLASSES_FOUND = 'classes-found'

export const CLASSES_NOT_FOUND = 'classes-not-found'

export const URL_RESPONSIBLE = '/cadastro/responsavel'

export const CHECK_ALL_CHECKBOX = 'checkAll'

export const REGISTER_COORDINATOR_DEFAULT_ERROR_MESSAGE =
  'Não foi possível fazer o vínculo do coordenador. Tente novamente.'
export const PERSON_PROVISIONAL_LOGIN_ID = 3

export const SCHOOL_ACCESS_CODE_VIEW = '/codigo-acesso/equipe-escolar'
export const BOOK_CODE_WRONG_VIEW_ERROR =
  'Este é um código de material didático, utilize-o na área de'
export const SCHOOL_CODE_WRONG_VIEW_ERROR =
  'Este é um código de equipe escolar, utilize-o na área de'
export const INVALID_ACCESS_CODE_ERROR =
  'Código inválido. Verifique se você digitou corretamente.'
export const SERVICE_VOUCHER_WRONG_VIEW_ERROR =
  'Este é um código para aulas particulares, utilize-o na área'

export const REGISTER_ROLE_DEFAULT_ERROR_MESSAGE =
  'Não foi possível fazer o vínculo do perfil. Tente novamente. '

export const EMAIL_REMOTE_MESSAGES = {
  INVALID: 'Email inválido. Verifique se você digitou corretamente.',
}
export const CPF_REMOTE_MESSAGES = {
  INVALID: 'Digite um formato de CPF válido.',
}
export const PASSWORD_REMOTE_MESSAGES = {
  INVALID: `A senha deve conter no mínimo ${PASSWORD_MIN_LENGTH} caracteres (letras ou números)`,
}

export const SMS_TOKEN_SIZE = 4

export const VALIDATE_MOBILE_RESEND_TIMEOUT_ONE_MINUTE = 1000 * 60

export const USER_PROFILE_END_AFTER_REGISTER_MOBILE = [
  USER_STUDENT_PROFILE,
  USER_RESPONSIBLE_PROFILE,
  USER_SERVICE_PROFILE,
]

export const REGISTER_TEACHER_DISCIPLINES_DEFAULT_ERROR_MESSAGE =
  'Não foi possível fazer o vínculo do perfil. Tente novamente mais tarde.'

export const ROLE_NAME_COORDINATOR = 'Coordenador'
